export const BTN_GET_APP_LINK = 'btn_get_app_link'
export const REDEEM_COUPON = 'btn_redeem_coupon'
export const VIEW_PAGE = 'view_page'
export const SAVINGS_LIST_SCREEN = 'savings_list_screen'
export const COUPONS_LIST_SCREEN = 'coupons_list_screen'
export const TAP_BTN_ENGAGE = 'tap_btn_engage'
export const R2D2_EKIND_HOME = 'new_home_wrapper_screen'
export const PRODUCT_BUTTON_EXPERIMENT_NAME = 'wrapper_v3'

export const JOURNEY_TYPES = {
  NCSA_REDEEMED: 'ncsa_redeemed',
  NCSA_AVAILABLE: 'ncsa_available',
  REWARDS: 'rewards',
  NEW_CAR_INSURANCE_NCSA: 'new_car_insurance_ncsa',
  NEW_CAR_PURCHASE_NCSA: 'new_car_purchase_ncsa',
} as const
